// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import EventTemplatesWrapper from './EventTemplatesListWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { mapFromActivityToTemplate } from '../../../../infrastructure/utils/events';
import { Activity, BookingOptionSubType } from '../../../../types/Activity';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const EventNonBookableActivities = ({ activities, children }) => {
  const [childrenWithProps, setChildrenWithProps] = useState(null);

  const onActivityClick = (activity: Activity) => {
    const { bookingOptions = [] } = activity;
    const { location } =
      bookingOptions.find(
        ({ subType }) => subType === BookingOptionSubType.bookingOption
      ) ?? {};
    const eventTemplate = {
      eventType: activity.type,
      eventCategory: activity.category,
      eventTitle: activity.title,
      eventLocation: location,
      defaultImageId: undefined,
      image: activity.pictures?.length > 0 ? activity.pictures[0] : undefined,
    };
    const childs = React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        return React.cloneElement(child, { eventTemplate });
      }
      return child;
    })[0];
    setChildrenWithProps(childs);
  };
  return (
    <>
      {childrenWithProps || (
        <EventTemplatesWrapper
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          templates={activities.map(mapFromActivityToTemplate)}
          onTemplateClick={onActivityClick}
          originalData={activities}
        />
      )}
    </>
  );
};

export default React.memo(EventNonBookableActivities);
